import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExpertiseEnMaitriseDoeuvre() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="expertise-en-maîtrise-dœuvre" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-primary py-20">
      {}
      <div className="absolute inset-0 z-0">
        <div className={`absolute inset-0 w-full bg-black/20 !p-0 !m-0 bg-cover bg-center bg-no-repeat !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/ff405b1ba9b816f25b07cad1a2191af4.jpg)] transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`} />
      </div>

      {}
      <div className="container relative z-10 px-4 md:px-6">
        <div ref={ref} className={`mx-auto transform transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <div className="border-border border text-center !rounded-none border-[rgb(224,231,235)] !shadow-none border-1 !border-none !opacity-[1] !bg-transparent !text-transparent !p-0 flex flex-col items-center">
            <h1 className={`mb-6 font-sans tracking-tight !font-semibold !text-[hsl(0,0%,100%)] !text-6xl !text-center transition-all duration-700 delay-300 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>Maitrise d'Oeuvre - Neuf et Rénovation</h1>
            
            <div className="mx-auto mb-8 !text-[hsl(163,88%,20%)] !w-[100px] !h-[6px] !rounded-[3.4px] !bg-[hsl(176,69%,22%)]" />
            
            <p className={`mx-auto max-w-2xl leading-relaxed !text-[hsl(0,0%,100%)] !text-[50px] !font-semibold transition-all duration-700 delay-500 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>L'Art de travailler autrement</p>

            <div className="mt-8 flex justify-center gap-4">
              <Button asChild size="lg" className="rounded-md text-base bg-accent hover:bg-accent/90 text-accent-foreground">
                
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}